import { Button, ValueChart } from '@opositandopn/ui';
import classnames from 'classnames';
import { IoArrowForwardCircleOutline } from 'react-icons/io5';

import { BaseComponentProps } from '../../../../types/base-component.types';
import { GRADE_FORMAT } from '../../../../utils/numbers';

import styles from './AssessmentMark.module.scss';

type ContainerProps = BaseComponentProps & {
  /**
   * The mark the simulacro has already been sat for. Nothing yet — no attempt —
   * puts the invitation to sit it in the mark's place.
   */
  score?: number;
  onStart: () => void;
  /** Lifts the invitation off the card; the hero card wants it, the smaller ones do not. */
  shadow?: boolean;
};

/**
 * Your mark on a simulacro, or the way to earn one. Both take the same room on the
 * card, so a sat simulacro and an unsat one keep their cards the same height and put
 * whatever follows on the same line.
 */
function AssessmentMark({
  className,
  score,
  onStart,
  shadow = false,
  testId = 'ui-assessment-mark',
}: ContainerProps) {
  return (
    <div className={classnames(styles['mark'], className)} data-testid={testId}>
      {score !== undefined ? (
        <ValueChart value={score} size="md" format={GRADE_FORMAT} />
      ) : (
        <Button
          className={styles['mark__start']}
          variant="primary"
          shadow={shadow}
          suffixIcon={<IoArrowForwardCircleOutline />}
          onClick={onStart}
        >
          Empezar el simulacro
        </Button>
      )}
    </div>
  );
}

export { AssessmentMark };
